import { Col } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";

export const DashboardCards = ({ icon, text, count = 0, redirect }) => {
  const navigate = useNavigate();
  return (
    <Col
      lg={5}
      sm={24}
      md={11}
      className={`dashboard-card ${redirect && "clickable"}`}
      onClick={() => {
        redirect && navigate(redirect);
      }}
    >
      <div className="icon-shape">
        <div>{icon}</div>
      </div>
      <div className="flex flex-col mt-4">
        <h5 className="dash-card-count">{count}</h5>
        <span className="dash-card-text">{text}</span>
      </div>
    </Col>
  );
};
